import { NgModule, Provider, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ContentParser, ContentDefaultParser } from './content.parser';
import { PIPES } from './pipes';
import { COMPONENTS } from './components';
import { DIRECTIVES } from './directives';
import { ContentHttpInterceptor } from './content.inteceptor';
import { CONTENT_FRAGMENT_PROVIDER, ContentFragmentProvider } from './content-fragment.provider';

export interface ContentModuleConfig {
  parser?: Provider;
  loader: Provider;
  compiler?: Provider;
  missingTranslationHandler?: Provider;
}

@NgModule({
  imports: [CommonModule],
  declarations: [...PIPES, ...DIRECTIVES, ...COMPONENTS],
  exports: [...PIPES, ...DIRECTIVES, ...COMPONENTS]
})
export class ContentModule {

  /**
   * Use this method in your root module to provide the TranslateService
   */
  static forRoot(config: ContentModuleConfig): ModuleWithProviders {
    return {
      ngModule: ContentModule,
      providers: [
        config.loader,
        config.parser || { provide: ContentParser, useClass: ContentDefaultParser},
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ContentHttpInterceptor,
          multi: true
        },
        {
          provide: CONTENT_FRAGMENT_PROVIDER,
          useClass: ContentFragmentProvider
        }
      ]
    };
  }

}
